(function (root) {
  'use strict';
  if (root.JEScriptNameCart) return;
  root.JEScriptNameCart = Object.freeze({ tokenProperty: '_Script name submission', payloadProperty: '_Script name payload',
    create(config = {}) {
      if (!root.JEBirthflowerCart?.create) throw new Error('The cart tools did not load. Refresh the page to try again.');
      return root.JEBirthflowerCart.create({ ...config, kind: 'script-name' });
    }
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
